import Visits from "../layouts/Visits.jsx";

var indexRoutes = [
  // { path: "/rtl", name: "RTL", component: RTL },
  // { path: "/pages", name: "Pages", component: Pages },
  // { path: "/", name: "Home", component: Dashboard }
  { path: "/visits", name: "Visits", component: Visits },
];

export default indexRoutes;
